import {create} from 'zustand';

interface UserAccessState {
  userAccess: any;
  setUserAccess: (data: any) => void;
}

export const useUserAccessStore = create<UserAccessState>(set => ({
  userAccess: null,
  setUserAccess: data => set({userAccess: data}),
}));
